import React from "react";
import { useState } from "react";

function Explore() {
  const [isSignIn, setIsSignIn] = useState(
    localStorage.getItem("isSignIn") === "true" || false
  );
  const [email, setEmail] = useState(localStorage.getItem("email") || "");
  const [username, setUsername] = useState(
    localStorage.getItem("username") || ""
  );
  const jumpToHome = () => {
    window.location.href = "/Home";
  };
  const jumpToProfile = () => {
    window.location.href = "/:Profile";
  };
  return (
    <>
      <nav className="navbar">
        <div className="navbar-container">
          <div className="navbar-logo">
            <h1>Chef's Kiss</h1>
          </div>
          <div className="navbar-user">
            <button
              className="btn btn-user"
              onClick={() => {
                jumpToHome();
              }}
            >
              Home
            </button>
            <button
              className="btn btn-user"
              onClick={() => {
                jumpToProfile();
              }}
            >
              {username}
            </button>
            <button
              className="btn btn-logout"
              onClick={() => {
                setIsSignIn(false);
                setEmail("");
                setUsername("");
                window.location.href = "/ ";
              }}
            >
              Logout
            </button>
          </div>
        </div>
      </nav>
      <div className="explore-container">
        <h1>this page has not yet been developed yet</h1>
      </div>
    </>
  );
}
export default Explore;
